<template>
  <div class="bxTjzbhxr">
    <div class="box noBtn">
      <div class="main">
        <table-tem
          ref="table"
          :config="tableConfig"
          :key="tableConfig.key"
          :span-method="objectSpanMethod"
          :highlightCurrentRow="false"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
          <template #sc="scope">
            <template>{{
              scope.data.complianceReview == 1
                ? "通过"
                : scope.data.complianceReview == 2
                ? "不通过"
                : ""
            }}</template>
          </template>
        </table-tem>
        <!-- <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{}}家</span> -->
      </div>
    </div>
  </div>
  <!-- <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div> -->
</template>

  <script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
  },
  data() {
    return {
      waitLoading: false,
      djlcId: "", //节点流程id
      tbdwmc: "",
      kbxmlc: {},
      tableConfig: {
        head: [],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
        key: 1,
        rowClassNameMethod: (row) => {
          return row.bz ? 'error-row' : ''
        }
      },
      scOptions: [
        { label: "请选择", id: "0" },
        { label: "通过", id: "1" },
        { label: "不通过", id: "2" },
      ],
      options: [
        {
          value: 1,
          label: "按投标单位审查",
        },
        {
          value: 2,
          label: "按分项审查",
        },
      ],
      tjzbhxr: null,
      tableData: [],
      number: [],
      dialogVisible: false,
      candidate: null,
      candidateOptions: [],
    };
  },
  created() {
    this.djlcId = this.$route.query.djlcId;
    this.tjzbhxr = 1;
    this.$nextTick(() => {
      this.getData();
    });
  },
  methods: {
    changeData(secondaryName, threeLevelName) {
      this.tableConfig.data = [];
      this.number = [];
      this.companyFlag = false;
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          k[threeLevelName].map((p, index) => {
            k[p.bjcsId] = p.csznr;
          });
        });
      }
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          let param = {
            ...v,
            qdmc: this.tjzbhxr == 1 ? k.qdmc : v.qdmc,
            qymc: this.tjzbhxr == 1 ? v.qymc : k.qymc,
            ...k,
          };
          this.tableConfig.data.push(param);
        });
      }
      for (let i = 0; i < this.tableData.length; i++) {
        this.number.push({
          qdmc: this.tableData[i].qdmc,
          num: this.tableData[i][secondaryName].length,
        });
      }
      let msgIndex = 0;
      let msgArr = [];
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        msgIndex += num;
        msgArr.push(msgIndex);
      }
      msgArr.pop();
      msgArr.unshift(0);
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        this.tableConfig.data[msgArr[i]].rowspan = num;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 如果是前两列，就使用idIndex数据来进行合并
      if (this.tjzbhxr == 1) {
        if ([0, 1, 2, 9, 10, 11].includes(columnIndex)) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      } else {
        if (columnIndex <= 2) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      }
    },
    getData(data) {
      this.once();
      this.$refs.table.$refs.tableTem.clearSelection();
      this.candidate = null;
      let para = {
        djlcId: this.djlcId,
        currentPage: this.tableConfig.currentPage,
        type: this.tjzbhxr,
        pageSize: this.tableConfig.pageSize,
      };
      para = Object.assign(para, data);
      this.waitLoading = true;
      this.$api
        .xbfhxscList(para)
        .then((res) => {
          if (res.data.meta.success) {
            let cgTbbjCsList = res.data.data.cgTbbjCsList || [];
            // cgTbbjCsList.map((item, index) => {
            //   this.tableConfig.head.splice(2 + index, 0, {
            //     key: item.id,
            //     title:
            //       item.cszmc + (item.bjlxdw ? "(" + item.bjlxdw + ")" : ""),
            //     align: "center",
            //   });
            // });
            // this.tableConfig.head.push({
            //   key: 'ip',
            //   title: 'IP',
            // });
            // this.tableConfig.head.push({
            //   key: 'bz',
            //   title: '备注',
            // });
            this.tableData = res.data.data.tbdwList.list;
            this.tableConfig.total = res.data.data.total;
            this.kbxmlc = res.data.data.kbxmlc;
            this.tableConfig.key++;
            this.changeData("tbdwQdTbdwResultList", "tbdwCsTbdwResultList");
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    once() {
      this.tableConfig.head = [
        {
          key: "xh",
          title: "序号",
          align: "center",
          width: 60,
        },
        {
          key: "qymc",
          title: "投标单位名称",
          align: "center",
        },
        {
          type: "slot",
          title: "审查",
          align: "center",
          slotName: "sc",
        },
      ];
    },

    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

  <style lang='scss' scoped>
.main {
  .main-top {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    .main-top-left {
      margin-bottom: 10px;
      label {
        margin-right: 20px;
      }
    }
  }
  .rightButton {
    position: absolute;
    right: 10px;
    top: 60px;
  }
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.clear {
  clear: initial !important;
}
.pageNum {
  position: relative;
  bottom: 50px;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: white;
}
::v-deep .el-table tr.error-row,
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #FFEED5;
}
</style>
